import React from 'react';
import { Link } from 'react-router-dom';
import { Tag } from 'lucide-react';

interface ArticleTagsProps {
  tags: string[];
}

const ArticleTags: React.FC<ArticleTagsProps> = ({ tags }) => {
  if (!tags || tags.length === 0) return null;
  
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Tag size={16} className="text-neutral-500" />
      {tags.map((tag, index) => (
        <Link 
          key={index}
          to={`/tag/${tag.toLowerCase().replace(/\s+/g, '-')}`}
          className="inline-block bg-neutral-100 hover:bg-neutral-200 text-neutral-700 text-sm rounded-full px-3 py-1 transition-colors"
        >
          {tag}
        </Link>
      ))}
    </div>
  );
};

export default ArticleTags;